import dayjs from "dayjs"
import { AbsencesTypes } from "../../../api/constants"
import { getDayCountOfAbsences } from "../../../services/functions"
import { Employee } from "../../Mitarbeiter/types/Types"
import { AbsenceType, AbsenceStatus } from "../types"

type PersonalAbsenceValuesType = {
    userSelf: Employee
    displayedAbsences: AbsenceType[]
}

export default function PersonalAbsenceValues(props: PersonalAbsenceValuesType) {
    return (
        <div className="flex flex-col w-full items-end border-t pt-4">
            <div className="text-sm text-gray-400 flex flex-row gap-4">
                <p className=" w-56">Urlaubstage {dayjs().year()} gesamt:</p>
                    <p className="w-8">{props.userSelf?.vacationContingentPerYear}</p>
            </div>
            <div className="text-sm text-gray-400 flex flex-row gap-4">
                <p className=" w-56">Urlaubstage {dayjs().year()} In Bearbeitung:</p>
                <p className="w-8">
                    {getDayCountOfAbsences(
                        props.displayedAbsences?.filter(
                            (absence: AbsenceType) => absence.type === AbsencesTypes.VACATION && absence.status === AbsenceStatus.IN_REVIEW
                        ) ?? []
                    )}
                </p>
            </div>
            <div className="text-sm text-gray-400 flex flex-row gap-4">
                <p className=" w-56">Urlaubstage {dayjs().year()} genehmigt:</p>
                <p className="w-8">
                    {getDayCountOfAbsences(
                        props.displayedAbsences?.filter(
                            (absence: AbsenceType) => absence.type === AbsencesTypes.VACATION && absence.status === AbsenceStatus.APPROVED
                        ) ?? []
                    )}
                </p>
            </div>
            <div className="text-sm text-gray-400 flex flex-row gap-4">
                <p className=" w-56">Urlaubstage {dayjs().year()} verfügbar:</p>
                <p className="w-8">
                    {(props.userSelf?.vacationContingentPerYear as number) -
                        getDayCountOfAbsences(
                            props.displayedAbsences?.filter(
                                (absence: AbsenceType) => absence.type === AbsencesTypes.VACATION && absence.status === AbsenceStatus.APPROVED
                            ) ?? []
                        ) -
                        getDayCountOfAbsences(
                            props.displayedAbsences?.filter(
                                (absence: AbsenceType) => absence.type === AbsencesTypes.VACATION && absence.status === AbsenceStatus.IN_REVIEW
                            ) ?? []
                        )}
                </p>
            </div>
        </div>
    )
}
